import React from "react";
import "../App.css";

const DisplayBox = ({content}) => {

    return(
        <>
        <div className="border-solid border-black border-2 p-1 m-1">
            <p>{content}</p>
        </div>
        </>
    );
};

export default DisplayBox;